<template>
  <el-dialog
    :visible="visible"
    title="关联方案"
    width="900px"
    class="support-combo-dialog"
    @opened="afterOpen"
    @close="onClose"
  >
    <!--
      v-model 与 combo-multi-picker 双向绑定，组件内部维护跨页已选。
      打开弹窗时从 supportComboIdList 回填已选方案。
    -->
    <combo-multi-picker
      ref="picker"
      v-model="selectedComboIds"
      :fetch-list="fetchComboList"
    />
    <div class="dialog-footer">
      <el-button size="small" @click="onClose">取 消</el-button>
      <el-button size="small" type="primary" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { editSupportCombo, getComboListForOrg } from "./api.js";
import ComboMultiPicker from "@/components/combo-multi-picker/index.vue";

export default {
  name: "SupportComboDialog",
  components: { ComboMultiPicker },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    // 机构资方 ID（用于提交）
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
    // 已关联的方案 ID 列表（用于回填）
    supportComboIdList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selectedComboIds: [],
    };
  },
  methods: {
    afterOpen() {
      // 直接用传入的方案 ID 列表回填
      this.selectedComboIds = Array.isArray(this.supportComboIdList)
        ? this.supportComboIdList.map((v) => Number(v))
        : [];
    },
    onClose() {
      // 清空到初始状态
      this.selectedComboIds = [];
      if (this.$refs.picker) {
        this.$refs.picker.reset();
      }
      this.$emit("update:visible", false);
    },
    async onSubmit() {
      await editSupportCombo({
        id: this.id,
        supportComboIdList: this.selectedComboIds,
      });
      this.$message.success("关联方案保存成功");
      this.onClose();
      this.$emit("refreshList");
    },
    fetchComboList(params) {
      return getComboListForOrg(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.support-combo-dialog {
  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 0;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 30px 0 10px;
  margin-top: 40px;
}
</style>
